module.exports = __webpack_public_path__ + "img/cnd_Authentication.b481dc60.svg";